import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: ['silde 1', 'slide 2', 'slide 3'],
    multi_button: ['button 1', 'button 2', 'button 3'],
    multi_left_button: ['never show 1', 'never show 2', 'never show 3'],
    multi_right_button: ['close 1', 'close 2', 'close 3']
  }
};

const CarouselSlideModalTracking: FC<any> = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
    }
    
    .center_tracking {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: end;    
      gap: 30px;
      padding-bottom: 110px;
    }

    .modal_wrapper_tracking {
      width: 100%;
      padding: 2rem 0 0 0;
      display: flex;
      flex-direction: column;
      gap: 50px;
    }

    .slick_wrapper {    
      width: 100%;
      height: 12rem;
    }   
  
    .bottom_wrapper_tracking {
      width: 100%;
      height: 5rem;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    .button_tracking {
      width: 100%;
      height: 2rem;
    }

    .edit_tracking {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center_tracking">
          <div className="modal_wrapper_tracking">
            <div className="edit_tracking">
              <EditTracking
                value={tracking?.multi_image?.[currentIndex]}
                type="multi_image"
              />
            </div>
            <div className="edit_tracking">
              <EditTracking
                value={tracking?.multi_button?.[currentIndex]}
                type="multi_button"
              />
            </div>
          </div>
          <div className="bottom_wrapper_tracking">
            <span className="button_tracking edit_tracking">
              <EditTracking
                value={tracking?.multi_left_button?.[currentIndex]}
                type="multi_left_button"
              />
            </span>
            <span className="button_tracking edit_tracking">
              <EditTracking
                value={tracking?.multi_right_button?.[currentIndex]}
                type="multi_right_button"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarouselSlideModalTracking;
